import { OnFail, OnSuccess } from "core";
import { Execute } from "./httpService";
import { Configuration, QrCodeCallResponse, QrCodeValidatorResponse } from "./types";

export const QrCodeRequest = (token: string, onSuccess: OnSuccess<QrCodeCallResponse>, onFail: OnFail): void => {
    const validate = /^\w{32}$/;
    if (!validate.test(token)) {
        onFail({ type: "InvalidToken" });
        return;
    }

    const config: Configuration = {
        url: `api/qrcode/${token}`,
        method: "GET"
    }

    Execute<QrCodeCallResponse>(config, onSuccess, onFail);
}

export const ValidateTokenRequest = (token: string, onSuccess: OnSuccess<QrCodeValidatorResponse>, onFail: OnFail): void => {
    const config: Configuration = {
        url: `api/qrcode/validate/${token}`,
        method: "GET"
    }

    Execute<QrCodeValidatorResponse>(config, onSuccess, onFail);
}
